module.exports = __webpack_public_path__ + "static/lol-cccdc8d9af1ee948b0854bd2250c7778.svg";